import(
  `../../${process.env.REACT_APP_FOLDER_NAME_URL}/modules/scss/signin.scss`
);

const configImport = import(
  `../../${process.env.REACT_APP_FOLDER_NAME_URL}/configs/app.config`
);

import React from "react";
import { useEffect, useReducer, useState } from "react";
import {
  PrivacySecurity,
  FormInput,
  Form,
  LoginFailed,
  AlphaNumericOnly,
  ReducerCore,
  InitStateCore,
  ActionTypesCore,
  AccountLocked,
  Utility,
  ObtainNewPasscode,
} from "@ovrture/react-tenant-lib";
import {
  recordsLogin,
  recordReset,
  recordsDetails,
  recordsForgotPassword,
  recordsPublicDetails,
  useNotification,
} from "@ovrture/react-redux";
import { useSelector, useDispatch } from "react-redux";
import UnderConstruction from "../../helpers/commonModule/underConstruction.module";
import {
  clearLocalStorageOnLoginScreen,
  DecodeJwtToken,
} from "../../helpers/migration/TenantMigration";
import { resetLoginUrl } from "../../helpers/logout";
import { removeInteractionResponse } from "../../helpers/surveyjs/store";

export function PasscodeLayout(props) {
  const { Toast } = useNotification();
  const [config, setConfig] = useState({});
  const [data, setData] = useState({});
  const [isUserAlreadyLogin, setisUserAlreadyLogin] = useState(null);
  const [colIsMagicLinkEnabled, setcolIsMagicLinkEnabled] = useState(null);
  const [shouldRenderUI, setShouldRenderUI] = useState(false);
  const [pausedStatus, setPausedStatus] = useState(false);
  const [state, dispatch] = useReducer(ReducerCore, InitStateCore);
  const [expiryMagicLinkModalInfo, setexpiryMagicLinkModalInfo] = useState({
    id: "expiryMagicLink",
    variant: "danger",
    modalTitle: "Expired Magic Link URL",
    modalBody:
      "Kindly click on the button below to have a magic link sent to you via email.",
    cancelBtnText: "Cancel",
    submitBtnText: "Send Magic Link",
  });
  const [passcodeModalInfo, setpasscodeModalInfo] = useState(null);
  const [modalInfo, setModalInfo] = useState(null);
  //let { recordId, year, system } = props?.match?.params;
  let paramsArray = window.location.pathname.split("/");
  let recordId = paramsArray[paramsArray?.length - 1];
  let year = /^\d+$/.test(paramsArray[paramsArray?.length - 2])
    ? paramsArray[paramsArray?.length - 2]
    : undefined;
  let isnum = /^\d+$/.test(year);
  const dispatchAction = useDispatch();
  const TenantPasscode = React.lazy(() =>
    import(
      `../../${process.env.REACT_APP_FOLDER_NAME_URL}/modules/passcode/passcode.module`
    )
  );

  const {
    user,
    lockedOut,
    error,
    details,
    forgotPassword,
    loading,
    publicDetailsData,
  } = useSelector((state) => {
    return {
      loading: state?.records?.loading,
      details: state?.records?.details,
      publicDetailsData: state?.records?.publicDetails?.data,
      forgotPassword:
        state?.records?.forgotPassword ||
        state?.records?.expiryMagicLinkPassword,
      lockedOut: state?.records?.lockedOut,
      user: state?.records?.user,
      error: state?.records?.error,
    };
  });

  useEffect(() => {
    let tenant_user = JSON.parse(localStorage.getItem("tenant_user"));
    let tokenTime = DecodeJwtToken(tenant_user?.token)?.exp * 1000 < Date.now();
    if (tenant_user) {
      tokenTime && resetLoginUrl(tenant_user);
      setisUserAlreadyLogin(true);
    }
    let magicToken = new URL(window.location.href).searchParams.get("token");
    dispatchAction(recordsPublicDetails());
    const payload = {
      url: recordId,
    };
    if (year && isnum) {
      payload["reportYear"] = year;
    } else {
      year = null;
    }
    dispatchAction(recordsDetails(payload));
    setTimeout(() => {
      if (!magicToken) {
        setShouldRenderUI(true);
      }
    }, 1000);
  }, []);

  useEffect(() => {
    // Public Details Data
    if (publicDetailsData) {
      if (year) {
        // Report
        if (publicDetailsData?.colIsMagicLinkEnabledForReport) {
          setcolIsMagicLinkEnabled(
            publicDetailsData?.colIsMagicLinkEnabledForReport
          );
          setpasscodeModalInfo({
            id: "newPasswordMagicLink",
            variant: "primary",
            modalTitle: "Obtain Magic Link",
            modalBody:
              "Kindly click on the button below to have a magic link sent to you via email.",
            cancelBtnText: "Cancel",
            submitBtnText: "Send Magic Link",
          });
        } else if (
          publicDetailsData?.colIsMagicLinkEnabledForReport === false
        ) {
          setpasscodeModalInfo({
            id: "newPassword",
            variant: "primary",
            modalTitle: "Obtain New Passcode",
            modalBody:
              "Kindly click on the button below to have a new passcode sent to you via email.",
            cancelBtnText: "Cancel",
            submitBtnText: "Send New Passcode",
          });
          setcolIsMagicLinkEnabled(null);
        }
      } else {
        // Site
        if (publicDetailsData?.colIsMagicLinkEnabledForSite) {
          setcolIsMagicLinkEnabled(
            publicDetailsData?.colIsMagicLinkEnabledForSite
          );
          setpasscodeModalInfo({
            id: "newPasswordMagicLink",
            variant: "primary",
            modalTitle: "Obtain Magic Link",
            modalBody:
              "Kindly click on the button below to have a magic link sent to you via email.",
            cancelBtnText: "Cancel",
            submitBtnText: "Send Magic Link",
          });
        } else if (publicDetailsData?.colIsMagicLinkEnabledForSite === false) {
          setpasscodeModalInfo({
            id: "newPassword",
            variant: "primary",
            modalTitle: "Obtain New Passcode",
            modalBody:
              "Kindly click on the button below to have a new passcode sent to you via email.",
            cancelBtnText: "Cancel",
            submitBtnText: "Send New Passcode",
          });
          setcolIsMagicLinkEnabled(null);
        }
      }
    }
  }, [publicDetailsData]);

  const magicLinkAuthentication = (magicLinkToken) => {
    if (magicLinkToken) {
      setisUserAlreadyLogin(false);
      localStorage.removeItem("magicPasscodeSet");
      let payload = {
        token: magicLinkToken,
        password: null,
        url: recordId,
        reportYear: Number(year),
        forReport: Number(year) ? true : false,
        recaptchaResponse: "6yyZR3kpwamw",
      };
      if (window?.location?.href?.includes("review")) payload.forReview = true;
      removeInteractionResponse();
      dispatchAction(recordsLogin(payload));
    }
  };
  const requestAccessMagicLinkAuthentication = () => {
    sessionStorage.setItem(
      process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY,
      "System administrator notified, Magic link to be sent ASAP."
    );
    const payload = {
      url: recordId,
      reportYear: Number(year),
      isReport: year !== undefined,
      recaptcha: "6yyZR3kpwamw",
    };
    sessionStorage.setItem(
      "headersConfigForgotPassword",
      JSON.stringify({
        headers: {
          referrer: window.location.href,
          originReferer: window.location.href,
        },
      })
    );
    dispatchAction(recordsForgotPassword(payload));
  };

  useEffect(() => {
    configImport.then((x) => setConfig(x.default));
  }, [configImport]);

  const favIcon = () => {
    const favicon = document.querySelector('link[rel="shortcut icon"]');
    if (favicon) {
      favicon.href = config.favIcon;
    } else {
      const newFavicon = document.createElement("link");
      newFavicon.rel = "shortcut icon";
      newFavicon.href = config.favIcon;
      document.head.appendChild(newFavicon);
    }
  };

  const changeTitleAndFav = () => {
    document.title = config.tenantName;
    favIcon();
  };
  changeTitleAndFav();

  useEffect(() => {
    if (details?.data && details?.code === 200) {
      let magicLinkToken = new URL(window.location.href).searchParams.get(
        "token"
      );
      if (magicLinkToken) {
        magicLinkAuthentication(magicLinkToken);
      }

      const obj = {
        email: "",
        phone: "",
      };
      const {
        reportExists,
        siteExists,
        publicOrganizationInfoDTO,
        prospectName,
      } = details?.data;
      if (!window?.location?.href?.includes("review")) {
        if (!reportExists && !siteExists) {
          props.history.push("/error");
        }
      } else {
        sessionStorage.setItem(
          process.env.REACT_APP_DASHBOARD_SESSION_AUTH_KEY,
          JSON.stringify({ forReview: true })
        );
      }
      if (publicOrganizationInfoDTO?.colIsShowAdminDetailForAllSite && !year) {
        obj.email = publicOrganizationInfoDTO?.colEmailIdForAllSite;
        obj.phone = publicOrganizationInfoDTO?.colPhoneNoForAllSite;
      } else if (
        publicOrganizationInfoDTO?.colIsShowAdminDetailForAllReport &&
        year
      ) {
        obj.email = publicOrganizationInfoDTO?.colEmailIdForAllReport;
        obj.phone = publicOrganizationInfoDTO?.colPhoneNoForAllReport;
      } else {
        obj.email = details?.data?.colRecordOwnerEmailId;
        obj.phone = details?.data?.contactNo;
      }
      setData({ ...obj, prospectName });
      dispatchAction(recordReset());
    }

    if (error) {
      if (error?.message === "User locked out.") {
        dispatch({
          type: ActionTypesCore.setShowAccountLocked,
          payload: true,
        });
      } else if (error?.code === 404) {
        props.history.push("/error");
      } else if (error === "Magic link expired.") {
        setShouldRenderUI(true);
        setModalInfo(expiryMagicLinkModalInfo);
        dispatch({
          type: ActionTypesCore.newPasscodeModalShow,
          payload: true,
        });
      } else if (error === "Invalid magic link.") {
        setShouldRenderUI(true);
        Toast.danger({
          description:
            "Invalid magic link. Please do forgot passcode to obtain new.",
        });
      } else if (error.includes("Magic link login is disabled for")) {
        setShouldRenderUI(true);
        Toast.danger({
          description: error,
        });
      } else {
        dispatch({
          type: ActionTypesCore.setLoginFailedModalShow,
          payload: true,
        });
      }
      dispatchAction(recordReset());
    }

    if (forgotPassword?.code === 202) {
      dispatch({
        type: ActionTypesCore.newPasscodeModalShow,
        payload: false,
      });
      dispatchAction(recordReset());
    }
  }, [details, error, forgotPassword]);

  useEffect(() => {
    if (lockedOut) {
      dispatch({
        type: ActionTypesCore.setShowAccountLocked,
        payload: true,
      });
    } else if (user?.token && user?.recordId === recordId) {
      //dispatchAction(recordReset());
      //if (!clearLocalStorageOnLoginScreen(user?.expiryDate)) {
      let url = new URL(window.location.href);
      let magicLinkToken = url.searchParams.get("token");
      if (magicLinkToken) {
        // if user already login & have magic link token
        if (isUserAlreadyLogin === false) {
          year && isnum
            ? (window.location.href = `/reports?year=${year}`)
            : (window.location.href = "/sites");
        }
      } else {
        year && isnum
          ? (window.location.href = `/reports?year=${year}`)
          : (window.location.href = "/sites");
      }
      // }
      //}
    }
  }, [user, lockedOut]);

  const onSubmit = (formData) => {
    if (formData.passcode === "")
      formData.passcode = document.getElementById("passcode").value;

    const payload = {
      url: recordId,
      password: Utility.convertIntoBase64(formData.passcode),
      reportYear: Number(year),
      forReport: Number(year) ? true : false,
      recaptchaResponse: "6yyZR3kpwamw",
    };
    if (window?.location?.href?.includes("review")) payload.forReview = true;
    localStorage.removeItem("magicPasscodeSet");
    setisUserAlreadyLogin(false);
    removeInteractionResponse();
    dispatchAction(recordsLogin(payload));
  };

  const _nameCapicity = (text) => {
    if (text?.length && text.length > 100) {
      return text.slice(0, 97) + "...";
    }
    return text;
  };

  const handleNewPasscode = () => {
    if (modalInfo?.id === "newPassword") {
      sessionStorage.setItem(
        process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY,
        "System administrator notified, Passcode to be sent ASAP."
      );
    } else {
      sessionStorage.setItem(
        process.env.REACT_APP_DASHBOARD_SESSION_GENERIC_MSG_KEY,
        "System administrator notified, Magic link to be sent ASAP."
      );
    }
    const payload = {
      url: recordId,
      reportYear: Number(year),
      isReport: year !== undefined,
      recaptcha: "6yyZR3kpwamw",
    };
    sessionStorage.setItem(
      "headersConfigForgotPassword",
      JSON.stringify({
        headers: {
          referrer: window.location.href,
          originReferer: window.location.href,
        },
      })
    );
    dispatchAction(recordsForgotPassword(payload));
  };

  return (
    <>
      {loading || !shouldRenderUI ? (
        <></>
      ) : pausedStatus && !window?.location?.href?.includes("review") ? (
        <UnderConstruction />
      ) : (
        !user && (
          <>
            <TenantPasscode
              config={config}
              onSubmit={onSubmit}
              _nameCapicity={_nameCapicity}
              data={data}
              privacyPolicyHandler={() =>
                dispatch({
                  type: ActionTypesCore.setModalShow,
                  payload: true,
                })
              }
              forgetPasswordHandler={() => {
                setModalInfo(passcodeModalInfo);
                dispatch({
                  type: ActionTypesCore.newPasscodeModalShow,
                  payload: true,
                });
              }}
              requestAccessLinkHandler={() => {
                requestAccessMagicLinkAuthentication();
              }}
            ></TenantPasscode>
            {/* {props.children} */}
            <PrivacySecurity
              id="privacySecurityModal"
              show={state.modalShow}
              onHide={() =>
                dispatch({ type: ActionTypesCore.setModalShow, payload: false })
              }
            />
            <LoginFailed
              title="Passcode Invalid"
              subTitle="The entered passcode is not valid. Please try again or contact the
                individual who shared this URL with you to obtain the correct
                passcode."
              btnYes="Confirm"
              id="commonLoginFailedModal"
              show={state.loginFailedModalShow}
              onHide={() =>
                dispatch({
                  type: ActionTypesCore.setLoginFailedModalShow,
                  payload: false,
                })
              }
            />
            <AccountLocked
              id="acount-locked"
              show={state.isAccountLocked}
              time={new Date(lockedOut)}
              onHide={() => {
                dispatchAction(recordReset());
                dispatch({
                  type: ActionTypesCore.setShowAccountLocked,
                  payload: false,
                });
              }}
            />
            <ObtainNewPasscode
              id={modalInfo?.id}
              handleNewPasscode={handleNewPasscode}
              show={state.newPasscodeModalShow}
              onHide={() => {
                dispatchAction(recordReset());
                dispatch({
                  type: ActionTypesCore.newPasscodeModalShow,
                  payload: false,
                });
              }}
              variant={modalInfo?.variant}
              modalTitle={modalInfo?.modalTitle}
              modalBody={modalInfo?.modalBody}
              cancelBtnText={modalInfo?.cancelBtnText}
              submitBtnText={modalInfo?.submitBtnText}
            />
          </>
        )
      )}
    </>
  );
}

export default PasscodeLayout;
